// Import model
import { StartProjectAppointmentSendOmwsmsRequest } from '../models/StartProjectAppointmentSendOmwsmsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartProjectAppointmentSendOmwsmsRequest - handles JSON serialization and deserialization with type validation
 */
export class StartProjectAppointmentSendOmwsmsRequestSerializer {
  /**
   * Deserializes a JSON string into a StartProjectAppointmentSendOmwsmsRequest instance
   */
  static deserialize(json: string): StartProjectAppointmentSendOmwsmsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartProjectAppointmentSendOmwsmsRequest instance
   */
  static fromObject(obj: any): StartProjectAppointmentSendOmwsmsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartProjectAppointmentSendOmwsmsRequest');
    }


    const instance: StartProjectAppointmentSendOmwsmsRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartProjectAppointmentSendOmwsmsRequest instances
   */
  static deserializeArray(json: string): StartProjectAppointmentSendOmwsmsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartProjectAppointmentSendOmwsmsRequest instance to a JSON string
   */
  static serialize(instance: StartProjectAppointmentSendOmwsmsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartProjectAppointmentSendOmwsmsRequest instance to a plain object
   */
  static toObject(instance: StartProjectAppointmentSendOmwsmsRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartProjectAppointmentSendOmwsmsRequest instances to a JSON string
   */
  static serializeArray(instances: StartProjectAppointmentSendOmwsmsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
